/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { request } from '@mairistem/tools';

import { useEntiteStore, useRegistreStore } from '@/zustand';
import { getLastRegistre } from '@/routes';
import type { ApiResponse, Registre } from '@/types';
import { AssistantContext } from '@/contexts';

interface RegistreZustandProviderProps {
  children: React.ReactNode;
}

const RegistreZustandProvider = (props: RegistreZustandProviderProps) => {
  const { children } = props;

  const { selectedDeclarationType } = React.useContext(AssistantContext);

  const entiteSelected = useEntiteStore((state) => state.selectedEntite);
  const setRegistre = useRegistreStore((state) => state.setRegistre);

  const typeRegistre = selectedDeclarationType === 'projet' ? 10 : 11;

  React.useEffect(() => {
    if (!_.isNil(entiteSelected) && !_.isNil(selectedDeclarationType)) {
      request
        .get(getLastRegistre(typeRegistre))
        .then(({ data }: ApiResponse<Registre>) => {
          const reg: Registre = data?.[0] || null;
          setRegistre(reg);
        });
    }
  }, [entiteSelected, setRegistre, selectedDeclarationType, typeRegistre]);

  return children;
};

export default RegistreZustandProvider;
